import { styled } from "@mui/material";

const Box = styled("div")(() => ({
  backgroundColor: "#fff",
  border: "1px solid #DCDFE8",
  borderRadius: 12,
  padding: 24,
}));

export default Box;
